<template>
	<div class="ctr" v-if="data">

		<div class="result-ctr">

			<div class="result-logo-ctr">
				<img :src="data.logo" class="result-logo" />
			</div>

			<div class="tips">{{data.tips}}</div>

			<div class="route-ctr">
				<el-button type="primary" class="el-button--success" icon="el-icon-monitor"
					@click="clickRoute(data.route)">{{data.route.name}}</el-button>

				<el-button type="primary" icon="el-icon-download" v-if="data.downloadRoute"
					@click="clickDownload(data.downloadRoute)">{{data.downloadRoute.name}}</el-button>

				<el-button type="primary" icon="el-icon-document" class="el-button--danger"
					@click="clickTicket()">开发票</el-button>
			</div>

		</div>


		<el-dialog title="开发票" :visible.sync="showTicketDilaog" append-to-body align='center'>
			<div class="tiket-ctr">
				<div class="form-ctr">
					<label class="ticket-title">单位名称</label>
					<el-input v-model="name" placeholder="请输入名字" class="input" required/>
				</div>

				<div class="form-ctr">
					<label class="ticket-title">税号</label>
					<el-input v-model="no" placeholder="请输入税号" class="input" required/>
				</div>

				<div class="form-ctr">
					<label class="ticket-title">手机号</label>
					<el-input v-model="mobile" type="mobile" placeholder="请输入手机号" class="input" required/>
				</div>

				<div class="form-ctr">
					<label class="ticket-title">邮箱</label>
					<el-input v-model="email" type="email" placeholder="请输入邮箱" class="input" required/>
				</div>


				<div class="dialog-footer" align="center">
					<el-button type="primary" class="el-button--info" size="medium" @click="closeInvoice()">关 闭</el-button>
					<el-button type="primary" size="medium" @click="commitTicket()">提 交</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		queryPayResult,
		getResult,
		commitInvoice
	} from "@/api/rank"

	export default {
		name: "Rank",
		data() {
			return {
				data: null,
				showTicketDilaog: false,
				name: '',
				no: '',
				mobile: '',
				email: ''
			}
		},
		created() {
			this.initPageData();
		},
		methods: {
			initPageData() {
				this.pageParams = this.$route.query
				console.log('this.pageParams', this.pageParams)
				this.out_trade_no = this.pageParams.out_trade_no

				queryPayResult({
					'out_trade_no': this.out_trade_no
				}).then(res => {
					let realData = res.data;
					this.data = realData;

					let downloadUrl = realData.downloadUrl

					if (downloadUrl != undefined && downloadUrl != '') {
						window.open(downloadUrl)
					}

				})
			},

			clickRoute(route) {
				window.location.href = route.path
			},

			clickDownload(route) {
				window.open(route.path)
			},

			clickTicket() {
				this.showTicketDilaog = true;
			},
			
			closeInvoice(){
				this.showTicketDilaog = false;
			},

			commitTicket() {
				let params = {
					'out_trade_no': this.out_trade_no,
					'name': this.name,
					'no': this.no,
					'mobile': this.mobile,
					'email': this.email
				}
				
				commitInvoice(params).then(res => {
					this.closeInvoice();
				});
			}
		}

	}
</script>
<style rel="stylesheet/scss" lang="scss">
	@use "mobile.scss" as *;
	.ctr {
		width: 100vw;
		height: 100vh;
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}

	.result-ctr {
		display: flex;
		flex-direction: column;
		align-items: center;
		margin-bottom: rem(200);
	}

	.result-logo-ctr {
		display: flex;
		flex-direction: row;
		justify-content: center;
	}

	.result-logo {
		width: rem(100);
		height: rem(100);
	}

	.tips {
		font-size: rem(15);
		margin-top: rem(30);
		color: red;
	}

	.route-ctr {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: rem(30);
	}

	.download-btn {
		margin-left: rem(50) !important;
	}
	
	.tiket-ctr{
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.form-ctr {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: rem(20);
	}

	.ticket-title {
		width: rem(120);
		text-align: left;
	}

	.input {
		width: rem(300);
	}
	
	.dialog-footer{
		margin-top: rem(30);
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		button{
			width: rem(300);
		}
	}
</style>